const getPageTitle = location => {
  if (location) {
    switch (location.pathname) {
      case '/u/sign-in': {
        return 'Sign In';
      }
      case '/u/register': {
        return 'Register';
      }
      case '/u/marketing-preferences':
        return 'My Marketing Preferences';
      default:
        return '';
    }
  } else {
    return '';
  }
};

export default getPageTitle;
